module.exports = __webpack_public_path__ + "static/media/providerInviteBackgroundTop.5c7cb26e.jpeg";